import { oc } from '@orpc/contract';
import { VOCAB_KINDS, VOCAB_NAME_MAX } from '@lsc/domain';
import { z } from 'zod';
export const vocabKind = z.enum(VOCAB_KINDS);
/** One value on a ticket picker (Settings, Categories and products tab). */
export const vocabItem = z.object({
    id: z.uuid(),
    kind: vocabKind,
    name: z.string(),
    sort: z.number().int(),
    /** Hidden values (`false`) leave the pickers; existing tickets keep their text. Only admins see them. */
    active: z.boolean(),
});
/** Both kinds in picker order. Everyone gets the active values; admins also get the hidden ones, flagged. */
export const vocabListOutput = z.object({ categories: z.array(vocabItem), products: z.array(vocabItem), viewerIsAdmin: z.boolean() });
const name = z.string().trim().min(1).max(VOCAB_NAME_MAX);
export const vocabContract = {
    list: oc.route({ method: 'POST', path: '/vocab/list', summary: 'Ticket categories and products, in picker order' }).output(vocabListOutput),
    add: oc.route({ method: 'POST', path: '/vocab/add', summary: 'Add a category or product (admins only)' }).input(z.object({ kind: vocabKind, name })).output(vocabItem),
    rename: oc.route({ method: 'POST', path: '/vocab/rename', summary: 'Rename a value (admins only)' }).input(z.object({ id: z.uuid(), name })).output(vocabItem),
    setActive: oc.route({ method: 'POST', path: '/vocab/set-active', summary: 'Hide or show a value (admins only)' }).input(z.object({ id: z.uuid(), active: z.boolean() })).output(vocabItem),
    reorder: oc
        .route({ method: 'POST', path: '/vocab/reorder', summary: 'Set the order of one kind, every id in its new place (admins only)' })
        .input(z.object({ kind: vocabKind, ids: z.array(z.uuid()).min(1).max(500) }))
        .output(vocabListOutput),
};
//# sourceMappingURL=vocab.js.map